module.exports = __webpack_public_path__ + "assets/img/Process.0a793ec4.svg";